import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';
import { PromiseState } from './PromiseState';

export class PromisesState {
  readonly promises = observable.array<PromiseState<unknown>>([], {
    deep: false,
  });

  constructor() {
    makeObservable(this, {
      push: action.bound,
      addPromise: action.bound,
      isLoadingPromises: computed,
    });
  }

  async addPromise<P>(createPromise: () => Promise<P>) {
    return this.push(
      new PromiseState({
        createPromise,
      }),
    );
  }

  async push<P>(promise: PromiseState<P>) {
    this.promises.push(promise);
    await promise.fetch();
    runInAction(() => {
      this.promises.remove(promise);
    });
  }

  get isLoadingPromises() {
    return this.promises.some((promise) => promise.status.isLoading);
  }
}
